module.exports = __webpack_public_path__ + "media/images/s01_04-495ff853358847eabd4cf4e252927b7c.svg";